import React from 'react';

import { Select, MenuItem, makeStyles, ListSubheader } from '@material-ui/core';
import styled from 'styled-components';

import theme from 'constants/theme';

import { Typography4, Typography5 } from 'uiToolkit/Typography';

const StyledUnderlineSelect = styled(Select)`
  width: ${(props) => props.width ?? '120px'};
  .MuiSelect-root {
    background: white;
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 16px;

    & .label-chip {
      display: none;
    }
  }
  fieldset {
    border: none;
    border-bottom: 1px dashed ${(props) => props.textColor ?? props.theme.palette.borders.lighterGrey};
    border-radius: 0px;
  }

  p {
    font-size: 16px;
    font-weight: 600;
  }
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.textColor ?? props.theme.palette.borders.lighterGrey};
  }

  svg {
    fill: ${(props) => (props.disabled ? 'transparent' : (props.textColor ?? theme.palette.text.heading))};
  }

  ${
    '' /* .MuiSelect-select {
    padding: 11px 32px 11px 0.8rem;
  } */
  }

  .MuiSelect-root > div {
    padding: 0;
    margin: 0;
    border-bottom: 0;
    height: fit-content;
    width: min-content;
  }
`;

const StyledSelect = styled(Select)`
  width: ${(props) => props.width ?? '120px'};
  min-width: ${(props) => props.minWidth ?? '0'};

  & fieldset {
    border: 1px solid ${(props) => (props.isStyle2 ? 'hsl(0,0%,80%)' : props.theme.palette.borders.primary)} !important;
  }
  &:hover {
    fieldset {
      border: ${(props) => (props.isStyle2 ? '1px' : '2px')} solid
        ${(props) => (props.isStyle2 ? 'hsl(0,0%,70%)' : props.theme.palette.borders.primary)} !important;
    }
  }
  &.MuiOutlinedInput-root.Mui-focused {
    fieldset {
      border: 2px solid ${(props) => props.theme.palette.borders.primary} !important;
    }
  }
  svg {
    color: ${(props) => (props.isStyle2 ? 'hsl(0,0%,70%)' : props.theme.palette.icons.blue)};
  }

  .MuiSelect-root {
    background-color: ${(props) => (props.disabled ? '#f2f2f2' : 'white')};
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 16px;
    height: 40px;
    display: flex;
    align-items: center;
    & .label-text > p {
      color: ${(props) =>
        props.disabled
          ? props.theme.palette.text.label
          : props.isStyle2
            ? props.theme.palette.text.heading
            : props.theme.palette.text.blue};
    }

    & .label-chip {
      display: none;
    }
  }

  .MuiSelect-root > div {
    padding: 0;
    margin: 0;
    border-bottom: 0;
  }
`;

const MenuItemWrapper = styled.div`
  width: 240px;
  padding: 0 24px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledMenuItem = styled(MenuItem)`
  &.MuiListItem-root {
    padding: 0;
  }
  &.MuiListItem-root.Mui-selected {
    background: ${theme.palette.background.blue.light.v2};
  }
`;

const Tag = styled(Typography4)`
  background: ${theme.palette.background.lightGrey3};
  border: 1px solid rgba(153, 153, 153, 0.2);
  border-radius: 4px;
  padding: 2px 16px;
`;

const StyledListSubheader = styled(ListSubheader)`
  border-top: 1px solid ${theme.palette.borders.lighterGrey};
  background: rgba(250, 250, 250, 1);
  padding-left: 24px;
  padding-right: 24px;
`;

const StyledOtherMenuItem = styled(StyledMenuItem)`
  background: rgba(247, 247, 247, 0.6);
`;

const useStyles = makeStyles({
  paper: {
    maxHeight: 'calc(60% - 96px)',
    boxShadow: '3px 4px 5px rgba(0, 0, 0, 0.11)',
    border: `1px solid ${theme.palette.background.lightGrey3}`,
  },
});

const TimeBoundSelect = ({
  onChange,
  menuItems,
  otherMenuItems = [],
  selectedValue,
  defaultValue,
  isUnderlineStyle = false,
  isStyle2 = false,
  ...props
}) => {
  const classes = useStyles();
  const Comp = isUnderlineStyle ? StyledUnderlineSelect : StyledSelect;

  return (
    <Comp
      value={selectedValue || ''}
      variant="outlined"
      displayEmpty
      onChange={onChange}
      defaultValue={defaultValue}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        getContentAnchorEl: null,

        PopoverClasses: {
          paper: classes.paper,
        },
      }}
      textColor={isUnderlineStyle ? theme.palette.text.primary : ''}
      isStyle2={!isUnderlineStyle && isStyle2}
      PopOver
      {...props}
    >
      {menuItems.map(({ label, value, tag = '' }) => (
        <StyledMenuItem key={value} value={value}>
          <MenuItemWrapper>
            <span className="label-text">
              <Typography4>{label}</Typography4>
            </span>
            {tag && (
              <span className="label-chip">
                <Tag>Current</Tag>
              </span>
            )}
          </MenuItemWrapper>
        </StyledMenuItem>
      ))}
      {otherMenuItems?.length > 0 && (
        <StyledListSubheader>
          <Typography5>Other Time Periods</Typography5>
        </StyledListSubheader>
      )}
      {otherMenuItems.map(({ label, value }) => (
        <StyledOtherMenuItem key={value} value={value}>
          <MenuItemWrapper>
            <span className="label-text">
              <Typography4>{label}</Typography4>
            </span>
          </MenuItemWrapper>
        </StyledOtherMenuItem>
      ))}
    </Comp>
  );
};

export default TimeBoundSelect;
